export { default } from './ArrowUp';
